import {
    SearchIconComponent as SourceSearchIconComponent,
} from 'SourceComponent/SearchIcon/SearchIcon.component';
import {ReactElement} from 'Type/Common.type';

import './SearchIcon.override.style.scss';

/** @namespace Steinkrueger/Component/SearchIcon/Component */
export class SearchIconComponent extends SourceSearchIconComponent {
    render(): ReactElement {
        return (
            <svg
              block="SearchIcon"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <path
                  d="M20.7337 19.4481L14.5351 13.2495C15.5476 11.9613 16.1522
                    10.338 16.1522 8.57612C16.1522 4.39861 12.7536 1 8.57607 1C4.39861 1 1 4.39861
                    1 8.57606C1 12.7535 4.39861 16.1521 8.57607 16.1521C10.3379 16.1521
                    11.9612 15.5476 13.2495 14.5351L19.4482 20.7337C19.6256 20.9113
                    19.8583 21 20.0909 21C20.3236 21 20.5563 20.9113 20.7337 20.7337C21.0888 20.3787
                    21.0888 19.8031 20.7337 19.4481ZM2.81818 8.57606C2.81818 5.40115 5.40116 2.81818
                    8.57607 2.81818C11.751 2.81818 14.334 5.40115 14.334 8.57606C14.334 11.751 11.751
                    14.3339 8.57607 14.3339C5.40116 14.3339 2.81818 11.751 2.81818 8.57606Z"
                  fill="#003E90"
                  stroke="#003E90"
                  strokeWidth="0.5"
                />
            </svg>
        );
    }
}

export default SearchIconComponent;
